// Attribute specific permission props
import {Locales} from '@netx/core-next/locales';

// TODO: Explain why - I cannot remember why - is it that only admins can administer the attibute templates themeselves?
export const attribute = {
	modes: ['read', 'write'],
};

export const modes = Locales((i18n) => ({
	read: i18n('i18n.read'),
	write: i18n('i18n.write'),
	delete: i18n('i18n.delete'),
}));

export const specialModes = Locales((i18n) => ({
	read: i18n('i18n.viewer'),
	write: i18n('i18n.contributor'),
	delete: i18n('i18n.manager'),
}));

export const resourceLabels = Locales((i18n) => ({
	attribute: i18n('i18n.attribute'),
	attributeSet: i18n('i18n.attributeSet'),
	savedCart: i18n('i18n.savedCart'),
	savedSearch: i18n('i18n.savedSearch'),
}));

export const targets = Locales((i18n) => ({
	all: i18n('i18n.all'),
	group: i18n('i18n.group'),
	user: i18n('i18n.user'),
}));

export default {
	attribute: attribute,
	modes: modes,
	resourceLabels: resourceLabels,
	specialModes: specialModes,
	targets: targets,
};
